// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b55d0d15","453":"f7be5b23","732":"758ff4b2"}[chunkId] + ".chunk.js";
};